import { Controller } from '@hotwired/stimulus'

export default class PaymentTypeSelectorController extends Controller {
  static targets = ['container']

  onChange (event) {
    this.containerTargets.forEach(container => {
      if (container.dataset.radioValue === event.target.value) {
        container.classList.remove('hidden')
      } else {
        container.classList.add('hidden')
      }
    })
  }
}
